import { render, staticRenderFns } from "./PaginationNav.vue?vue&type=template&id=2498f14c&scoped=true&"
import script from "./PaginationNav.vue?vue&type=script&lang=ts&"
export * from "./PaginationNav.vue?vue&type=script&lang=ts&"
import style0 from "./PaginationNav.vue?vue&type=style&index=0&id=2498f14c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2498f14c",
  null
  
)

export default component.exports